import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";

const UsptoPatentPdfLink = ({ grantNumber }) => {
  const url = `https://image-ppubs.uspto.gov/dirsearch-public/print/downloadPdf/${grantNumber}`;
  const styleIcon = {
    marginLeft: 4
  };
  return grantNumber ? (
    <Tooltip title="View USPTO PDF">
      <a href={url} target="_blank" rel="noopener noreferrer nofollow" style={styleIcon}>
        <FilePdfOutlined />
      </a>
    </Tooltip>
  ) : null;
};

UsptoPatentPdfLink.propTypes = {
  grantNumber: PropTypes.string.isRequired
};

export default UsptoPatentPdfLink;
